import { Link, Typography } from '@material-ui/core';
import { MouseEvent, ReactNode } from 'react';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { WebViewSMSLink } from 'shared/routing/WebViewLinks';
import { trackLoadboardEvent } from '../LoadboardAnalytics';
import { UserSettingsPhoneState } from './data/LoadboardUserSettingsDTO';

function ChangePhoneLink({ children }: { children: ReactNode }) {
  return (
    <Link
      color="primary"
      rel="noreferrer"
      target="_blank"
      // eslint-disable-next-line no-restricted-syntax
      href="/tms/users"
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        if (MobileAppBridge.openDriverInformation()) {
          event.preventDefault();
        }
      }}
    >
      {children}
    </Link>
  );
}

interface NotificationSettingPhoneWarningProps {
  state: UserSettingsPhoneState;
}

export function NotificationSettingPhoneWarning({
  state,
}: NotificationSettingPhoneWarningProps) {
  const isWebView = MobileAppBridge.isInjected();

  return state === 'missing' ? (
    <Typography align="center" color="textSecondary">
      <ChangePhoneLink>Add phone</ChangePhoneLink> to enable SMS
    </Typography>
  ) : state === 'invalid' ? (
    <Typography align="center" color="textSecondary">
      Incorrect phone. <ChangePhoneLink>Update</ChangePhoneLink> to enable SMS.
    </Typography>
  ) : state === 'blacklisted' ? (
    <Typography
      display="block"
      component="span"
      color="textPrimary"
      style={{ marginTop: 8 }}
    >
      SMS updates are blocked. To re-enable, send “START” to{' '}
      {isWebView ? (
        <WebViewSMSLink
          phone="+1 844-731-1331"
          onClick={() => {
            trackLoadboardEvent({
              name: 'SLB: Tapped Reply To Blacklisted SMS',
            });
          }}
        />
      ) : (
        '+1 844-731-1331'
      )}
    </Typography>
  ) : null;
}
